import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'
import { format } from 'date-fns'

const DATE_PARAM = 'date'
const ISO_DAY = /^\d{4}-\d{2}-\d{2}$/

/** Today in the browser's timezone, YYYY-MM-DD. */
export function localToday(): string {
  return format(new Date(), 'yyyy-MM-dd')
}

/**
 * The day the dashboard describes, kept in `?date=` so a past view can be
 * shared. `null` means live (today); a date on or after today is live too.
 */
export function useDashboardDate(): {
  date: string | null
  setDate: (next: string | null) => void
} {
  const [searchParams, setSearchParams] = useSearchParams()
  const raw = searchParams.get(DATE_PARAM)
  const date = raw && ISO_DAY.test(raw) && raw < localToday() ? raw : null

  const setDate = useCallback(
    (next: string | null) => {
      const params = new URLSearchParams(searchParams)
      if (!next || next >= localToday()) params.delete(DATE_PARAM)
      else params.set(DATE_PARAM, next)
      setSearchParams(params, { replace: true })
    },
    [searchParams, setSearchParams]
  )

  return { date, setDate }
}
